<template>
  <Layout>
    <section
      class="pt-32 pb-20"
      :style="{ backgroundImage: `url(${bgImage})` }"
    >
      <div class="pb-8 flex justify-center">
        <div class="w-40">
          <router-link :to="{ name: 'Home' }">
            <img
              src="../assets/logo_esri_blanco.png"
              alt="Conferencia Esri España 2020"
            />
          </router-link>
        </div>
        <!-- <LogoEsriSpain width="320" color="white" /> -->
      </div>

      <article class="px-4">
        <h1 class="text-4xl text-white">
          Regístrate para acceder al GeoExperience Center
        </h1>

        <AuthTooManyRequests v-if="tooManyRequests" />

        <transition v-else-if="formSent" name="fade">
          <div class="mt-8">
            <router-link class="cursorn-pointer" :to="{ name: 'Login' }">
              <BaseAlert class="alert-secondary">
                ¡Enhorabuena! Tu registro para GeoExperience Center de Esri
                España ha sido realizado correctamente. Ya puedes
                <span class="font-bold">
                  acceder a ella utilizando tu dirección de email
                </span>
              </BaseAlert>
            </router-link>
          </div>
        </transition>

        <div class="pt-8">
          <form
            class="max-w-sm mx-auto md:max-w-xl lg:max-w-2xl"
            novalidate
            @submit.prevent="sendData"
          >
            <div class=" md:flex md:flex-wrap">
              <div class="input-cont">
                <BaseInputText
                  ref="firstName"
                  label="Nombre"
                  name="firstName"
                  class="mb-4"
                  :value="firstName"
                  :v="$v.firstName"
                  @input="updateFirstName"
                  @blur="$v.firstName.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  label="Apellidos"
                  name="lastName"
                  class="mb-4"
                  :value="lastName"
                  :v="$v.lastName"
                  @input="updateLastName"
                  @blur="$v.lastName.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  label="Teléfono de contacto"
                  name="phoneNumber"
                  class="mb-4"
                  :value="phoneNumber"
                  :v="$v.phoneNumber"
                  @input="updatePhoneNumber"
                  @blur="$v.phoneNumber.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  type="email"
                  label="Email de contacto profesional"
                  name="email"
                  class="mb-4"
                  :value="email"
                  :v="$v.email"
                  @input="updateEmail"
                  @blur="$v.email.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  label="Empresa"
                  name="company"
                  class="mb-4"
                  :value="company"
                  :v="$v.company"
                  @input="updateCompany"
                  @blur="$v.company.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  label="Cargo"
                  name="position"
                  class="mb-4"
                  :value="position"
                  :v="$v.position"
                  @input="updatePosition"
                  @blur="$v.position.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  label="Código Postal"
                  name="zipCode"
                  class="mb-4"
                  :value="zipCode"
                  :v="$v.zipCode"
                  @input="updateZipCode"
                  @blur="$v.zipCode.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseSelect
                  :value="country"
                  name="country"
                  class="mb-4"
                  default-text="País"
                  :option-list="
                    getOptionList(countries, 'pk', 'pk', 'country', country)
                  "
                  :v="$v.country"
                  @input="updateCountry"
                  @change="$v.country.$touch()"
                  @blur="$v.country.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseSelect
                  :value="role"
                  name="role"
                  class="mb-4"
                  default-text="Rol"
                  :option-list="getOptionList(roles, 'pk', 'pk', 'role', role)"
                  :v="$v.role"
                  @input="updateRole"
                  @change="$v.role.$touch()"
                  @blur="$v.role.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseSelect
                  :value="industry"
                  name="industry"
                  class="mb-4"
                  default-text="Industria"
                  :option-list="
                    getOptionList(industries, 'pk', 'pk', 'industry', industry)
                  "
                  :v="$v.industry"
                  @input="updateIndustry"
                  @change="$v.industry.$touch()"
                  @blur="$v.industry.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseSelect
                  :value="companyType"
                  name="companyType"
                  class="mb-4"
                  default-text="Tipo de Compañía"
                  :option-list="
                    getOptionList(
                      companyTypes,
                      'pk',
                      'pk',
                      'companyType',
                      companyType
                    )
                  "
                  :v="$v.companyType"
                  @input="updateCompanyType"
                  @change="$v.companyType.$touch()"
                  @blur="$v.companyType.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseSelect
                  :value="companySize"
                  name="companySize"
                  class="mb-4"
                  default-text="Tamaño de la Compañía"
                  :option-list="
                    getOptionList(
                      companySizes,
                      'pk',
                      'pk',
                      'companySize',
                      companySize
                    )
                  "
                  :v="$v.companySize"
                  @input="updateCompanySize"
                  @change="$v.companySize.$touch()"
                  @blur="$v.companySize.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseSelect
                  :value="arcgisUse"
                  name="arcgisUse"
                  class="mb-4"
                  default-text="Uso de la Tecnología ArcGIS"
                  :option-list="
                    getOptionList(arcgisUses, 'pk', 'pk', 'use', arcgisUse)
                  "
                  :v="$v.arcgisUse"
                  @input="updateArcgisUse"
                  @change="$v.arcgisUse.$touch()"
                  @blur="$v.arcgisUse.$touch()"
                />
              </div>
            </div>

            <div class=" md:flex md:flex-wrap">
              <div class="input-cont">
                <BaseInputText
                  type="password"
                  label="Contraseña"
                  name="password"
                  class="mb-4"
                  :value="password"
                  :v="$v.password"
                  @input="updatePassword"
                  @blur="$v.password.$touch()"
                />
              </div>

              <div class="input-cont">
                <BaseInputText
                  type="password"
                  label="Repite Contraseña"
                  name="repeatPassword"
                  class="mb-4"
                  :value="repeatPassword"
                  :v="$v.repeatPassword"
                  @input="updateRepeatPassword"
                  @blur="$v.repeatPassword.$touch()"
                />
              </div>
            </div>

            <div class="text-white">
              <div>
                <BaseCheckbox
                  :value="checkPrivacy"
                  name="privacy"
                  :v="$v.checkPrivacy"
                  @checkboxClick="updateCheckPrivacy"
                >
                  He leído y acepto la
                  <BaseLink
                    href="https://www.esri.es/es-es/privacy/polilica-de-proteccion-de-datos/pol-tica-de-protecci-n-de-datos"
                    target="_blank"
                    class="link"
                  >
                    Política de Protección de Datos
                  </BaseLink>
                </BaseCheckbox>
              </div>

              <div>
                <BaseCheckbox
                  :value="checkAds"
                  name="ads"
                  :v="$v.checkAds"
                  @checkboxClick="updateCheckAds"
                >
                  Acepto recibir Newsletters, invitación a eventos y, novedades
                  e información sobre productos y servicios.
                </BaseCheckbox>
              </div>

              <div>
                <BaseCheckbox
                  :value="checkPartners"
                  name="partners"
                  :v="$v.checkPartners"
                  @checkboxClick="updateCheckPartners"
                >
                  Autorizo la cesión de mis datos, para remitirme comunicaciones
                  comerciales y/o publicitarias, a
                  <BaseLink
                    :to="{ name: 'Home', hash: '#partners' }"
                    class="link"
                  >
                    empresas patrocinadoras y colaboradoras de Esri España.
                  </BaseLink>
                </BaseCheckbox>
              </div>

              <div>
                <BaseCheckbox
                  class="text-white"
                  :value="checkNotice"
                  name="notice"
                  :v="$v.checkNotice"
                  @checkboxClick="updateCheckNotice"
                >
                  Acepto que queda prohibida la grabación de la sesión mediante
                  vídeo o audio y la captación de fotografías en cualquier
                  soporte, así como su difusión a terceros y su publicación en
                  internet. El asistente puede incurrir en incumplimientos de la
                  normativa vigente en materia de protección de datos. ESRI se
                  exime de las posibles responsabilidades en que puedan
                  incurrirse por el incumplimiento de esta prohibición, pudiendo
                  adoptar las acciones civiles o penales que considere
                  oportunas.
                  <template v-slot:error>
                    <div>
                      Es necesario leer y aceptar este aviso para poder
                      finalizar el registro
                    </div>
                  </template>
                </BaseCheckbox>
              </div>
            </div>
            <LoadingButton class="mt-8" :loading="sendingData">
              Inscribirse
            </LoadingButton>
          </form>
        </div>
      </article>
    </section>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  minLength,
  maxLength,
  sameAs,
} from 'vuelidate/lib/validators'
import updateFieldMixin from '@/mixins/updateFieldMixin'
import baseSelectMixin from '@/mixins/baseSelectMixin'
import utmParamsMixin from '@/mixins/utmParamsMixin'
import { checked } from '@/validators'
import Layout from '@/layouts/HomeLayout'
import AuthTooManyRequests from '@/components/AuthTooManyRequests'
import LoadingButton from '@/components/LoadingButton'

export default {
  components: { Layout, AuthTooManyRequests, LoadingButton },
  mixins: [validationMixin, updateFieldMixin, baseSelectMixin, utmParamsMixin],

  computed: {
    ...mapState('forms', ['sendingData']),
    ...mapState('home', ['mainContent']),
    ...mapState('auth', [
      'countries',
      'roles',
      'industries',
      'companyTypes',
      'companySizes',
      'arcgisUses',
      'firstName',
      'lastName',
      'phoneNumber',
      'email',
      'company',
      'position',
      'zipCode',
      'country',
      'role',
      'industry',
      'companyType',
      'companySize',
      'arcgisUse',
      'password',
      'repeatPassword',
      'checkPrivacy',
      'checkAds',
      'checkPartners',
      'checkNotice',
      'passwordMinLength',
      'formSent',
      'tooManyRequests',
    ]),

    bgImage() {
      if (this.mainContent && this.mainContent.bg_image_url) {
        return this.mainContent.bg_image_url
      }

      return '/img/home-background.jpg'
    },
  },

  mounted() {
    this.$store.dispatch('home/fetchHomeContents')
    this.$store.dispatch('auth/fetchRegisterParams')
    this.$refs.firstName.$el.querySelector('input').focus()
    window.fbq('track', 'PageView')
  },

  methods: {
    updateFirstName(e) {
      this.$store.commit('auth/setTooManyRequests', false)
      this.$store.commit('auth/updateFormSent', false)
      this.updateField(e, 'auth/updateFirstName', 'firstName')
    },

    updateLastName(e) {
      this.updateField(e, 'auth/updateLastName', 'lastName')
    },

    updatePhoneNumber(e) {
      this.updateField(e, 'auth/updatePhoneNumber', 'phoneNumber')
    },

    updateEmail(e) {
      this.updateField(e, 'auth/updateEmail', 'email')
    },

    updateCompany(e) {
      this.updateField(e, 'auth/updateCompany', 'company')
    },

    updatePosition(e) {
      this.updateField(e, 'auth/updatePosition', 'position')
    },

    updateZipCode(e) {
      this.updateField(e, 'auth/updateZipCode', 'zipCode')
    },

    updateCountry(e) {
      this.updateField(this.formatValue(e), 'auth/updateCountry', 'country')
    },

    updateRole(e) {
      this.updateField(this.formatValue(e), 'auth/updateRole', 'role')
    },

    updateIndustry(e) {
      this.updateField(this.formatValue(e), 'auth/updateIndustry', 'industry')
    },

    updateCompanyType(e) {
      this.updateField(
        this.formatValue(e),
        'auth/updateCompanyType',
        'companyType'
      )
    },

    updateCompanySize(e) {
      this.updateField(
        this.formatValue(e),
        'auth/updateCompanySize',
        'companySize'
      )
    },

    updateArcgisUse(e) {
      this.updateField(this.formatValue(e), 'auth/updateArcgisUse', 'arcgisUse')
    },

    updatePassword(e) {
      this.updateField(e, 'auth/updatePassword', 'Password')
    },

    updateRepeatPassword(e) {
      this.updateField(e, 'auth/updateRepeatPassword', 'repeatPassword')
    },

    updateCheckPrivacy() {
      this.$store.commit('auth/toggleCheckPrivacy')
    },

    updateCheckAds() {
      this.$store.commit('auth/toggleCheckAds')
    },

    updateCheckPartners() {
      this.$store.commit('auth/toggleCheckPartners')
    },

    updateCheckNotice() {
      this.$store.commit('auth/toggleCheckNotice')
    },

    loginAndRedirectHome() {
      this.$store.dispatch('auth/resetUserData')
      let url = { name: 'Home' }
      this.$router.push(url)
    },

    sendData() {
      this.$v.$touch()

      let payload = {
        first_name: this.firstName,
        last_name: this.lastName,
        phone_number: this.phoneNumber,
        email: this.email,
        company: this.company,
        position: this.position,
        zip_code: this.zipCode,
        country: this.country,
        role: this.role,
        industry: this.industry,
        company_type: this.companyType,
        company_size: this.companySize,
        arcgis_use: this.arcgisUse,
        privacy: this.checkPrivacy,
        ads: this.checkAds,
        partners: this.checkPartners,
        notice: this.checkNotice,
        password: this.password,
        repeat_password: this.repeatPassword,
      }

      const utm_params = this.getUtmParams()
      payload = { ...payload, ...utm_params }

      if (!this.$v.$invalid) {
        this.$store.dispatch('auth/registerUser', payload).then(() => {
          this.loginAndRedirectHome()
        })
      }
    },
  },

  validations() {
    return {
      firstName: { required, maxLength: maxLength(200) },
      lastName: { required, maxLength: maxLength(200) },
      phoneNumber: { required, maxLength: maxLength(30) },
      email: { required, email, maxLength: maxLength(255) },
      company: { required, maxLength: maxLength(200) },
      position: { required, maxLength: maxLength(200) },
      zipCode: { required, maxLength: maxLength(15) },
      country: { required },
      role: { required },
      industry: { required },
      companyType: { required },
      companySize: { required },
      arcgisUse: { required },
      password: { required, minLength: minLength(6) },
      repeatPassword: { required, sameAsPassword: sameAs('password') },
      checkPrivacy: { checked },
      checkAds: {},
      checkPartners: {},
      checkNotice: { checked },
    }
  },
}
</script>

<style scoped>
@screen md {
  .input-cont {
    @apply w-1/2 px-2;
  }
}
</style>

<style scoped>
section {
  @apply min-h-screen;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}
</style>
